module.exports = __webpack_public_path__ + "img/胶囊.d839fd15.png";